import { debounce } from 'lodash'

import {
  insertIntoGrid,
  clearGrid,
  removeLoadMoreContainer,
} from '../helpers/grid'

import {
  addLoadingNotificationSpinnerEl,
  removeLoadingNotificationSpinnerEl,
} from '../helpers/loading-notification'

import ee from '../ee'

let filtersFormEl = null
let paginatedGridEl = null
let unfilteredOnlyEls = null

var throttledMakeRequest = debounce(makeRequest, 500, {
  leading: false,
  trailing: true,
})

const request = new XMLHttpRequest()

function makeRequest(url) {
  hideErrorMessage()
  request.open('GET', url, true)

  request.onload = function () {
    if (request.status === 200) {
      const data = request.responseText
      removeLoadingNotificationSpinnerEl(paginatedGridEl)
      insertIntoGrid(data, paginatedGridEl)
    } else {
      showErrorMessage()
    }
  }

  request.send()
}

function convertFormDataToObject(data) {
  let formObj = {}
  data.forEach((item) => {
    if (!formObj[item[0]]) {
      formObj[item[0]] = [item[1]]
    } else {
      formObj[item[0]].push(item[1])
    }
  })
  return formObj
}

function showErrorMessage() {
  const errorMessageEl = document.querySelector('.js-filter-grid-error-message')
  errorMessageEl.innerHTML =
    'Sorry, there has been an error. Please try again later.'
  errorMessageEl.classList.remove('hidden')
}

function hideErrorMessage() {
  const errorMessageEl = document.querySelector('.js-filter-grid-error-message')
  errorMessageEl.classList.add('hidden')
}

function getFormDataObject() {
  const formData = new FormData(filtersFormEl)
  const data = [...formData.entries()]
  const formObj = convertFormDataToObject(data)
  return formObj
}

function constructUrl() {
  const formObj = getFormDataObject()
  const qs = new URLSearchParams(formObj).toString()
  return `${location.protocol}//${location.host}${location.pathname}?${qs}`
}

function replaceBrowserUrl(url) {
  window.history.replaceState({}, document.title, url)
}

function submitForm() {
  const url = constructUrl()
  replaceBrowserUrl(url)
  showUnfilteredOnlyElsCheck()
  throttledMakeRequest(url)
}

function resetFiltering() {
  request.abort()
  removeLoadingNotificationSpinnerEl(paginatedGridEl)
  clearGrid(paginatedGridEl.querySelector('.js-grid'))
  removeLoadMoreContainer(paginatedGridEl)
}

function applyFilters() {
  resetFiltering()
  addLoadingNotificationSpinnerEl(paginatedGridEl)
  submitForm()
}

function addFilterFormHandlers() {
  if (filtersFormEl) {
    const filterCheckboxEls = filtersFormEl.querySelectorAll(
      'input[type="checkbox"]'
    )

    Array.from(filterCheckboxEls).forEach((el) => {
      el.addEventListener('click', (e) => {
        applyFilters()
      })
    })
  }
}

function showUnfilteredOnlyElsCheck() {
  if (unfilteredOnlyEls) {
    const formObj = getFormDataObject()

    if (
      Object.keys(formObj).length === 0 ||
      (Object.keys(formObj).length === 1 &&
        'q' in formObj &&
        formObj.q.length === 1 &&
        formObj.q[0] === '')
    ) {
      Array.from(unfilteredOnlyEls).forEach((el) => {
        el.classList.remove('hidden')
      })
    } else {
      Array.from(unfilteredOnlyEls).forEach((el) => {
        el.classList.add('hidden')
      })
    }
  }
}

function init(container = document) {
  filtersFormEl = container.querySelector('.js-filters-form')
  paginatedGridEl = container.querySelector('.js-paginated-grid')
  unfilteredOnlyEls = container.querySelectorAll(
    '.js-index-page-show-when-unfiltered'
  )

  addFilterFormHandlers()
}

ee.addListener('initComponents', init)
